export default {
    youHave: '您有',
    todoItems: '条新的待办',
    batchSuccess: '条待办已批量处理完成',
    batchFail: '条任务未处理完成',
    batchProcess: '批量处理审批中，请稍侯',
    failReason: '失败原因',
    attachment: '附件',
    signature: '手写签名',
    approveFail: '未通过审批',
    approveSuggestion: '审批意见',
    noBatchWorkitemTip: '待办列表未包含可批量处理的任务，不可切换至批量处理模式',
    unselectWorkitem: '您还未选中待办哦',
    timeOut: '已超时',
    goingTimeOut: '后超时',
    timeoutLater: '后超时',
    haveWaitFor: '已等待',
    days: '天',
    hours: '小时',
    minutes: '分钟',
    lessOneMinute: '时间小于1分钟',
    batch: '批量',
    batchApprove: '批量同意',
    selectAll: '全选',
    completed: '完成',
    haveSelected: '已选',
    markMultiRead: '标为已阅',
    toreadItems: '条新的待阅',
    notSelectUnread: '您还未选中待阅哦~',
    reciveTime: '接收时间',
    approvalTime: '审批时间',
    agree: '同意',
    reject: '驳回',
    forward: '转办',
    canceled: '取消',
    unresolved: '未处理',
    readTime: '已阅时间',
    curActivity: '当前节点',
    stayTime: '停留时间',
    batchHandle: '批量处理',
    cancelBatch: '取消批量',
    templateName: '流程模板:',
    flowItems: '个流程',
    commonFlow: '常用流程',
    haveSearch: '查询到',
    items: '条结果',
    historySearch: '历史搜索',
    beUrged: '被催办',
    loadAllWorkflow: '已加载全部流程',
    usedTime: '已用时：',
    costTime: '耗时：',
    finishTime: '完成时间：',
    cancelTime: '作废时间：',
    resolveTime: '处理时间',
};
